import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { a34, a34Layout, a34Mq } from '@/components/Auction34/tokens';

/** 탭 전환 시 패널·히어로 등장 */
export const tabIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: none; }
`;

export const twinkle = keyframes`
  0%, 100% { opacity: 0.55; }
  50% { opacity: 1; }
`;

const Page = styled.div`
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: radial-gradient(
    120% 90% at 50% 18%,
    #fffcf7 0%,
    #fbf7f1 52%,
    #f6efea 100%
  );
  box-shadow: inset 0 0 180px rgba(104, 64, 160, 0.07);
`;

const PageContent = styled.div`
  position: relative;
  z-index: 1;
  padding: 22px ${a34.space.shellPadX} 72px;
`;

/** 모바일 상단 인라인 로고 (데스크톱에서는 배경 장식의 팻말이 대신합니다) */
const MobileSign = styled.div`
  display: none;
  justify-content: center;
  margin: 0 0 2px;

  img {
    display: block;
    width: min(132px, 38%);
    height: auto;
  }

  ${a34Mq.mobile} {
    display: flex;
  }
`;

const Panel = styled.main`
  max-width: ${a34Layout.maxWidth};
  margin-inline: auto;
  padding: clamp(22px, 4vw, 42px) clamp(14px, 3vw, 36px);
  background: rgba(255, 253, 250, 0.92);
  border: 1px solid rgba(199, 154, 69, 0.2);
  border-radius: clamp(18px, 3vw, ${a34.radius.panel});
  box-shadow: ${a34.shadow.panel};
`;

const TabPanel = styled.section`
  animation: ${tabIn} 250ms ease-out both;
`;

/** 화면에는 안 보이고 스크린리더에만 읽히는 텍스트 */
const SrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export { Page, PageContent, MobileSign, Panel, TabPanel, SrOnly };
